import { render, staticRenderFns } from "./BoxOsModalQrCode.vue?vue&type=template&id=c4932926&"
import script from "./BoxOsModalQrCode.vue?vue&type=script&lang=js&"
export * from "./BoxOsModalQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports